<script>
  import RfpManagerDropdownActions from 'rfp/rfp-manager/main/pages/components/RfpManagerDropdownActions.svelte';

  export let userAccount, userType, isEditable = false, onChange = () => {};

  function onInput(ev){
    onChange(ev.detail.label);
  }
</script>

<div class="Header">
  <div class="ProfilePicture">
    {#if userAccount.profilePicture}
      <img
        src="{`/images/users/${userAccount.profilePicture}`}"
        alt="{userAccount.fullName}"
      >
    {:else}
      <div class="Logo" data-icon-before="person"></div>
    {/if}
  </div>

  <div class="Details">
    <div class="Name">{userAccount.fullName}</div>

    <div>
      {#if isEditable && !userAccount.currentUser}
        <RfpManagerDropdownActions
          items="{[{id: 0, label: 'Administrator'}, {id: 1, label: 'Account Manager'}]}"
          align="bottom-end"
          mode="Light"
          grow="{true}"
          on:input={onInput}
        >
          <div slot="value"
               class="TypeDetail"
               data-icon-before="account_circle">
            User Type - { userType }
          </div>
        </RfpManagerDropdownActions>
      {:else}
        <div class="TypeDetail"
             data-icon-before="account_circle">
          User Type - { userType }
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="stylus">


  .Header {
    display: flex;
    gap: 10px;
    color: #37474f;
    padding: 14px 10px 0;
  }

  .ProfilePicture {
    flex: 0 0 64px;
    height: 64px;
    width: 64px;
    border-radius 3px;
    border 1px solid #ECEFF1;
    background: #ECEFF1;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing border-box;
    text-align: center;
    overflow: hidden;

    img {
      object-fit: contain;
      font-size: 12px;
      height: 64px;
      width: 64px;
    }

    div:before {
      font-size 50px;
    }
  }

  .Details {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .Name {
    font-size: 15px;
    font-weight: 600;
  }

  .TypeDetail {
    font-size: 13px;
    font-weight: normal;
    color: #546e7a;
    display: flex;

    &:before {
      color: #00b8aa;
      font-size: 18px;
      margin-right: 3px;
    }
  }


</style>
